import React from "react";
import styles from "./styles/error-text.module.scss";

type ErrorTextProps = {
  error?: string;
};
const ErrorText = ({ error }: ErrorTextProps) => {
  return <div className={styles.error_text}>{error}</div>;
};

export default ErrorText;
